function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { schema } from 'prosemirror-markdown';
import { generateVariable } from './schema/utils';
import { Schema as _Schema } from 'prosemirror-model';
import { isInlineDocFormat } from './utils';
export class Schema {
  constructor(args) {
    _defineProperty(this, "docFormat", void 0);
    _defineProperty(this, "variables", void 0);
    _defineProperty(this, "schema", void 0);
    Object.assign(this, args);
    this.schema = new _Schema({
      nodes: {
        ...this.nodes,
        ...this.variableNodes,
        pillbox: {
          inline: true,
          group: 'inline',
          draggable: true,
          atom: true,
          selectable: true,
          attrs: {
            token: {},
            label: {}
          },
          toDOM(node) {
            const {
              label
            } = node.attrs;
            const classNames = ['ProseMirror__pillbox'];
            if (!label) {
              classNames.push('ProseMirror__pillbox--invalid');
            }
            return ['span', {
              class: classNames.join(' ')
            }, label || 'Unknown'];
          },
          parseDOM: [{
            tag: 'span.ProseMirror__pillbox'
          }]
        },
        heading: {
          ...schema.nodes.heading.spec,
          content: '(text | inline)*'
        }
      },
      marks: this.marks
    });
  }
  get nodes() {
    if (isInlineDocFormat(this.docFormat)) {
      return this.inlineNodes;
    } else {
      return this.markdownNodes;
    }
  }
  get marks() {
    if (isInlineDocFormat(this.docFormat)) {
      return {};
    } else {
      const marks = {};
      schema.spec.marks.forEach((k, value) => {
        marks[k] = value;
      });
      return {
        ...marks
      };
    }
  }
  get inlineNodes() {
    return {
      text: {},
      doc: {
        content: '(text | inline)*',
        attrs: {
          format: {
            default: this.docFormat
          }
        }
      }
    };
  }
  get markdownNodes() {
    const nodes = {};
    schema.spec.nodes.update('doc',
    // eslint-disable-next-line ember/use-ember-get-and-set
    Object.assign({}, schema.spec.nodes.get('doc'), {
      attrs: {
        format: {
          default: this.docFormat
        }
      }
    })).update('ordered_list',
    // eslint-disable-next-line ember/use-ember-get-and-set
    Object.assign({}, schema.spec.nodes.get('ordered_list'), {
      attrs: {
        order: {
          default: 1
        },
        tight: {
          default: true
        }
      }
    })).update('bullet_list',
    // eslint-disable-next-line ember/use-ember-get-and-set
    Object.assign({}, schema.spec.nodes.get('bullet_list'), {
      attrs: {
        tight: {
          default: true
        }
      }
    })).forEach((k, value) => {
      nodes[k] = value;
    });
    return nodes;
  }
  get variableNodes() {
    const nodes = {};
    if (this.variables) {
      this.variables.forEach(variable => {
        const variableNodeSpec = generateVariable(variable);
        nodes[variable] = variableNodeSpec;
      });
      nodes['invalidVariable'] = generateVariable('invalid');
    }
    return nodes;
  }
}